/**
 * Vuex.Store主入口
 * @author LiQingSong
 */
import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import user from "./modules/user";
import qwwz from "./modules/qwwz";
import SMS from "./modules/SMS";
import { getByKeys } from "../service/commonApi";
import { g_tools } from "../service/GenerateAI/toolkit";
import { requestQueue } from "../utils/requestQueue";
import { Message } from "element-ui";
// import permission from "./modules/permission";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    openTopUp: false, // 打开充值弹窗
    showInvite: false, // 邀请好友弹窗
    currentMenu: 1,
    apolloConfig: {}, // apollo配置
    sseData: [], // sse消息数据
    currentPath: "",
    customModelType: "public",
    toolImg: "",
    currentView: 'LandingPage', //  提案正难题页面
    currentProps: {},
    notification: {
      show: false,
      message: '',
      type: 'info'
    }
  },
  modules: {
    user,
    qwwz, // 青蛙王子专用存储模块
    SMS, // 短信验证码模块
    // permission,
  },
  mutations: {
    SET_CURRENT_VIEW(state, view) {
      state.currentView = view
    },
    SET_CURRENT_PROPS(state, props) {
      state.currentProps = props
    },
    SHOW_NOTIFICATION(state, { message, type = 'info' }) {
      state.notification = {
        show: true,
        message,
        type
      }
    },
    HIDE_NOTIFICATION(state) {
      state.notification.show = false
    },
    SET_CUSTOM_MODEL_TYPE(state, customModelType) {
      state.customModelType = customModelType;
    },
    SET_OPEN_TOPUP(state, openTopUp) {
      state.openTopUp = openTopUp;
    },
    SET_SHOW_INVITE(state, showInvite) {
      state.showInvite = showInvite;
    },
    setCurrentMenu(state, val) {
      state.currentMenu = val;
    },
    SET_APOLLO_CONFIG(state, apolloConfig) {
      state.apolloConfig = apolloConfig;
    },
    SET_SSE_MESSAGE(state, { path, taskName, image, prompt, message }) {
      let hasMessage = state.sseData.some((item) => {
        if (item.path === path) {
          item.message = message;
          return true;
        }
      });
      if (!hasMessage) {
        state.sseData.push({ path, taskName, message, image, prompt });
      }
    },
    DEL_SSE_MESSAGE(state, path) {
      state.sseData = state.sseData.filter((item) => item.path !== path);
    },
    SET_TOOL_IMG(state, img) {
      state.toolImg = img;
    }
  },
  actions: {
    setCurrentView({ commit }, view) {
      commit('SET_CURRENT_VIEW', view)
    },
    setCurrentProps({ commit }, props) {
      commit('SET_CURRENT_PROPS', props)
    },
    showNotification({ commit }, { message, type, duration = 3000 }) {
      commit('SHOW_NOTIFICATION', { message, type })
      setTimeout(() => {
        commit('HIDE_NOTIFICATION')
      }, duration)
    },
    // 获取apollo配置
    getApolloConfig({ commit }, { nameSpace = "COMMON", keys = [] }) {
      return new Promise((resolve, reject) => {
        getByKeys({ nameSpace, keys, }).then((res) => {
          if (res.code === 1) {
            let configInfo = {}
            for (let key in res.data) {
              configInfo[key] = JSON.parse(res.data[key]);
            }
            commit("SET_APOLLO_CONFIG", configInfo);
            resolve(res.data);
          } else {
            reject(res.message);
          }
        });
      });
    },
    // 设置SSE消息弹框处理
    async setSSEMessage({ commit }, { data, path, taskName }) {
      if (requestQueue.has(path)) {
        Message({
          message: "已有任务在执行，请等待任务完成后再添加新任务",
          type: "error",
        })
        return
      }
      requestQueue.add(path, async () => {
        const response = await g_tools(data)
        if (!response.ok) {
          Message({
            message: "请求失败，请稍后再试",
            type: "error",
          })
          commit("SET_SSE_MESSAGE", { path, taskName, image: data.imageUrls, prompt: data.prompt, message: { code: 2 } });
          return
        }
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let loop = true;
        while (loop) {
          const { value, done } = await reader.read();
          if (done) {
            loop = false;
            break;
          }
          let chunk = decoder.decode(value, { stream: true });
          chunk = chunk.split("data: ")[1]
          let message = JSON.parse(chunk);
          commit("SET_SSE_MESSAGE", { path, taskName, image: data.imageUrls, prompt: data.prompt, message: message });
        }
      })
    },
    // 打开咨询
    consult() {
      var iTop = (window.screen.height - 600 - 30) / 2; //获得窗口的垂直位置;
      var iLeft = (window.screen.width - 800 - 10) / 2; //获得窗口的水平位置;
      // window.open(
      //   "https://p.qiao.baidu.com/cps/chat?siteId=17696256&userId=36621408&siteToken=ed6dc6e38d4e8a4a4e605f409f5e1f22",
      //   "_blank",
      //   "left=" +
      //   iLeft +
      //   ",top=" +
      //   iTop +
      //   ",width=800,height=600,menubar=no,toolbar=no,status=no,scrollbars=yes"
      // );
      window.open("https://work.weixin.qq.com/kfid/kfcda38c705e292e69c", "_blank");
    },
  },
  getters
});
